var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#6B7280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C6.986 2 2.5 6.486 2.5 12C2.5 17.514 6.986 22 12.5 22C18.014 22 22.5 17.514 22.5 12C22.5 6.486 18.014 2 12.5 2ZM20.431 11H17.667C17.5436 8.81124 16.9313 6.67797 15.875 4.757C17.0992 5.32905 18.1589 6.2014 18.9554 7.29291C19.752 8.38442 20.2596 9.65965 20.431 11ZM13.03 4.027C14.065 5.391 15.457 7.807 15.657 11H9.53C9.669 8.404 10.524 5.972 11.981 4.026C12.153 4.016 12.325 4 12.5 4C12.679 4 12.854 4.016 13.03 4.027ZM9.188 4.727C8.204 6.618 7.636 8.762 7.53 11H4.569C4.74177 9.64784 5.25663 8.3621 6.06489 7.26442C6.87315 6.16673 7.94808 5.29339 9.188 4.727ZM4.569 13H7.543C7.679 15.379 8.208 17.478 9.099 19.23C7.88119 18.6559 6.82773 17.7842 6.03596 16.6953C5.24419 15.6064 4.73966 14.3355 4.569 13ZM11.95 19.973C10.549 18.275 9.722 15.896 9.541 13H15.654C15.446 15.773 14.537 18.196 13.051 19.972C12.869 19.984 12.687 20 12.5 20C12.314 20 12.133 19.984 11.95 19.973ZM15.961 19.201C16.916 17.407 17.499 15.3 17.652 13H20.43C20.2612 14.3243 19.764 15.5853 18.9834 16.6684C18.2029 17.7514 17.1639 18.622 15.961 19.201Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.f5da99ba8fa09b2a7014d08fe77f942c.svg";
export { ForwardRef as ReactComponent };